<template>
  <b-modal
    id="fan-type-modal"
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    content-class="gnv-flow-modal-content"
    body-class="gnv-flow-modal-body p-0"
  >
    <div class="gnv-flow-modal gnv-flow-modal--dark-theme">
      <div class="gnv-flow-modal__top-bar" />

      <div class="gnv-flow-modal__inner">
        <h4 class="gnv-flow-modal__title">
          {{ title }}
        </h4>

        <p class="gnv-flow-modal__subtitle">
          {{ description }}
        </p>

        <div class="gnv-flow-modal__actions">
          <button
            type="button"
            class="gnv-flow-modal__btn gnv-flow-modal__btn--primary"
            :style="gnvModalPrimaryButtonStyle"
            @click="selectAtleticano"
          >
            {{ atleticanoButtonText }}
          </button>
          <button
            type="button"
            class="gnv-flow-modal__btn"
            :style="gnvModalSecondaryButtonStyle"
            @click="selectVisitante"
          >
            {{ visitanteButtonText }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import gnvModalMixin from '@/mixins/gnvModalMixin'

export default {
  name: 'FanTypeModal',
  mixins: [gnvModalMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    title() {
      return this.gnvFlow.fanTypeModalTitle || this.$t('gnv.fanTypeTitle')
    },
    description() {
      return this.gnvFlow.fanTypeModalDescription || this.$t('gnv.fanTypeDescription')
    },
    atleticanoButtonText() {
      return this.gnvFlow.fanTypeAtleticanoButtonText || this.$t('gnv.fanTypeAtleticano')
    },
    visitanteButtonText() {
      return this.gnvFlow.fanTypeVisitanteButtonText || this.$t('gnv.fanTypeVisitante')
    },
  },
  methods: {
    selectAtleticano() {
      this.$emit('select', 'atleticano')
    },
    selectVisitante() {
      this.$emit('select', 'visitante')
    },
  },
}
</script>
